import { Box, Button, Typography } from "@mui/material";
import ManageJobsTable from "../../components/ManageJobsTable/ManageJobsTable";
import { NavLink } from 'react-router-dom';
import ExternalResumeUploadDialog from "../../components/ExternalResumes/ExternalResumeUploadDialog";
import { useState } from "react";


const ManageJobs: React.FC = () => {
    const [isUploadDialogOpen, setIsUploadDialogOpen] = useState(false);

    return (
        <Box
            sx={{
                width: '100%',
                marginLeft: 'auto',
                marginRight: 'auto',
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
                <NavLink to={"/manage-jobs/applicants/all"}>
                    <Button
                        variant="outlined"
                        sx={{
                            borderColor: "#1976d2",
                            color: "#1976d2",
                            "&:hover": {
                                borderColor: "#1565c0",
                                backgroundColor: "rgba(25, 118, 210, 0.08)"
                            }
                        }}>
                        View Applicants For All Jobs
                    </Button>
                </NavLink>
                <Typography
                    variant="h5"
                    fontWeight="bold">
                    Job Postings
                </Typography>
                <Button
                    variant="outlined"
                    onClick={() => setIsUploadDialogOpen(true)}
                    sx={{
                        borderColor: "#1976d2",
                        color: "#1976d2",
                        "&:hover": {
                            borderColor: "#1565c0",
                            backgroundColor: "rgba(25, 118, 210, 0.08)"
                        }
                    }}>
                    Upload External Resumes
                </Button>
                <NavLink to={"/manage-jobs/create"}>
                    <Button
                        variant="contained"
                        sx={{
                            backgroundColor: "#1976d2",
                            "&:hover": {
                                backgroundColor: "#1565c0"
                            }
                        }}>
                        Create New Job
                    </Button>
                </NavLink>
            </Box>
            <ManageJobsTable />
            <ExternalResumeUploadDialog
                open={isUploadDialogOpen}
                onClose={() => setIsUploadDialogOpen(false)}
            />
        </Box>
    );
}

export default ManageJobs;